import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  width: 100%;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
  }
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 3rem;
  > h2,
  > p {
    margin: 2.25rem;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    display: grid;
    grid-auto-columns: 1fr;
    grid-template-rows: repeat(10, min-content);
    margin: 3rem auto 0;
    column-gap: 1.5rem;
    max-width: 1200px;
  }
`;

export const Heading = styled.h2`
  color: ${({ $sectionContainerHeadingColor }) =>
    $sectionContainerHeadingColor
      ? themeGet(`colors.${$sectionContainerHeadingColor}`)
      : themeGet(`colors.main-text`)};
  margin-bottom: 1rem;
`;

export const Header = styled.div`
  width: calc(100% - 40px);
  margin: 0 auto;
  text-align: ${({ $contentAlignment }) => $contentAlignment || 'left'};

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: 100%;
  }
`;
